import { tips } from "@/mocks/comicGuide";

export default function Tips() {
  return (
    <section id="tips" className="w-full bg-accent-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs text-accent-900">
            <i className="ri-lightbulb-flash-line text-sm"></i>
            阅读贴士
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl text-foreground-900">
            这样读，体验更舒服
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            几个小技巧，让下拉、翻页、全屏和夜间阅读都更顺手。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {tips.map((tip) => (
            <article
              key={tip.title}
              className="flex flex-col rounded-lg bg-background-50 border border-background-200 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className={`${tip.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-900">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}